// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"224":"6ca74bd7","946":"50e3d6fe"}[chunkId] + ".js";
};